/*! movtech-fx.js — Movtech gamifikációs vizuális effektek (SVG/DOM, emoji nélkül)
 *  Márkaszínek: piros #CD2026, grafit #1D1D1D, fehér #FFFFFF, réz akcent #C8745A.
 *  Használat:
 *    MovtechFX.confetti();                      // konfetti-robbanás
 *    MovtechFX.fireworks();                     // SVG tűzijáték
 *    MovtechFX.sparkle(x, y);                   // csillám egy pontnál
 *    MovtechFX.checkPop();                      // pipa-pop középen (vagy elemre)
 *    MovtechFX.coin(el);  MovtechFX.badge(el);  // érme / jelvény pop
 *    MovtechFX.celebrate();                     // FŐ győzelem: tűzijáték+konfetti+pipa
 *  Minden effekt automatikusan eltakarítja magát.
 */
(function (global, doc) {
  var RED = '#CD2026', INK = '#1D1D1D', WHITE = '#FFFFFF', COPPER = '#C8745A';
  var PALETTE = ['#2F6FED', '#1FAA59', RED, '#F5C518', WHITE];  // Csaba: kék, zöld, piros, sárga, fehér
  var SVGNS = 'http://www.w3.org/2000/svg';
  var layer = null, styled = false;

  function ready(fn){ if(doc.readyState!=='loading') fn(); else doc.addEventListener('DOMContentLoaded', fn); }
  function getLayer() {
    if (layer && layer.isConnected) return layer;
    layer = doc.createElement('div');
    layer.setAttribute('data-movtech-fx', '');
    var s = layer.style;
    s.position = 'fixed'; s.inset = '0'; s.pointerEvents = 'none';
    s.zIndex = '2147483600'; s.overflow = 'hidden';
    doc.body.appendChild(layer);
    return layer;
  }
  function injectStyle() {
    if (styled) return; styled = true;
    var css =
      '@keyframes mtfx-spark{0%{transform:translate(-50%,-50%) scale(0) rotate(0);opacity:0}' +
      '20%{opacity:1}100%{transform:translate(-50%,-50%) scale(1.4) rotate(90deg);opacity:0}}' +
      '@keyframes mtfx-pop{0%{transform:translate(-50%,-50%) scale(.2);opacity:0}' +
      '55%{transform:translate(-50%,-50%) scale(1.15);opacity:1}100%{transform:translate(-50%,-50%) scale(1);opacity:1}}' +
      '@keyframes mtfx-popout{0%{opacity:1}100%{opacity:0;transform:translate(-50%,-50%) scale(1.3)}}' +
      '@keyframes mtfx-ring{0%{transform:translate(-50%,-50%) scale(.2);opacity:.8}100%{transform:translate(-50%,-50%) scale(1.8);opacity:0}}' +
      '@keyframes mtfx-coin{0%{transform:translate(-50%,-50%) rotateY(0) scale(.4);opacity:0}' +
      '20%{opacity:1}100%{transform:translate(-50%,-50%) rotateY(900deg) scale(1);opacity:1}}' +
      '@keyframes mtfx-badge{0%{transform:translate(-50%,-50%) scale(0) rotate(-30deg);opacity:0}' +
      '60%{transform:translate(-50%,-50%) scale(1.12) rotate(6deg);opacity:1}100%{transform:translate(-50%,-50%) scale(1) rotate(0)}}' +
      '@keyframes mtfx-burst{0%{transform:scale(.05);opacity:1}70%{opacity:1}100%{transform:scale(1);opacity:0}}' +
      '@keyframes mtfx-streak{0%{transform:translateY(0) scaleY(.3);opacity:0}30%{opacity:1}100%{transform:translateY(var(--rise)) scaleY(1);opacity:0}}' +
      '@keyframes mtfx-fly{0%{transform:translate(-50%,-50%) scale(.3) rotate(0);opacity:0}15%{opacity:1}' +
      '100%{transform:translate(calc(-50% + var(--dx)),calc(-50% + var(--dy))) scale(1) rotate(var(--rot));opacity:0}}';
    var st = doc.createElement('style'); st.textContent = css; doc.head.appendChild(st);
  }
  function vw(){ return global.innerWidth; }
  function vh(){ return global.innerHeight; }
  function rnd(a,b){ return a + Math.random()*(b-a); }
  function pick(arr){ return arr[(Math.random()*arr.length)|0]; }

  // ---------- KONFETTI (DOM-darabkák, fizikával) ----------
  function confetti(opts) {
    opts = opts || {};
    var L = getLayer();
    var n = opts.count || 130;
    var ox = opts.x != null ? opts.x : vw()/2;
    var oy = opts.y != null ? opts.y : vh()*0.42;
    var spread = opts.spread || 1;
    var pieces = [];
    for (var i = 0; i < n; i++) {
      var d = doc.createElement('div');
      var size = rnd(6, 12);
      var st = d.style;
      st.position = 'absolute'; st.left = ox + 'px'; st.top = oy + 'px';
      st.width = size + 'px'; st.height = (size * rnd(0.45, 0.8)) + 'px';
      st.background = pick(PALETTE);
      st.borderRadius = Math.random() < 0.3 ? '50%' : '1px';
      if (st.background === WHITE) st.boxShadow = '0 0 0 1px rgba(0,0,0,.12)';
      st.willChange = 'transform,opacity';
      L.appendChild(d);
      var ang = rnd(-Math.PI, 0) + (Math.random()<0.5?0:0); // felfelé szórás
      var speed = rnd(7, 17) * spread;
      pieces.push({ el: d, x: ox, y: oy,
        vx: Math.cos(rnd(0, Math.PI*2)) * rnd(3,9) * spread,
        vy: -rnd(9, 18) * spread,
        rot: rnd(0,360), vr: rnd(-12,12), life: 0, ttl: rnd(90,150) });
    }
    var grav = 0.42, drag = 0.985;
    function frame() {
      var alive = 0;
      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i]; if (!p.el) continue;
        p.vy += grav; p.vx *= drag; p.vy *= drag;
        p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life++;
        var op = p.life > p.ttl*0.7 ? Math.max(0, 1 - (p.life - p.ttl*0.7)/(p.ttl*0.3)) : 1;
        p.el.style.transform = 'translate(' + (p.x-(opts.x!=null?opts.x:vw()/2)) + 'px,' + (p.y-oy) + 'px) rotate(' + p.rot + 'deg)';
        p.el.style.opacity = op;
        if (p.life < p.ttl && p.y < vh()+40) alive++;
        else { p.el.remove(); p.el = null; }
      }
      if (alive > 0) global.requestAnimationFrame(frame);
    }
    global.requestAnimationFrame(frame);
  }

  // ---------- TŰZIJÁTÉK (canvas részecske-rendszer, valósághű) ----------
  function fwSound(){ try{ if (global.MovtechSFX && global.MovtechSFX.enabled !== false) global.MovtechSFX.play('firework'); }catch(e){} }
  function fireworks(opts) {
    opts = opts || {};
    var L = getLayer();
    var dpr = Math.min(global.devicePixelRatio || 1, 2);
    var canvas = doc.createElement('canvas');
    canvas.style.position = 'absolute'; canvas.style.left = '0'; canvas.style.top = '0';
    canvas.style.width = '100%'; canvas.style.height = '100%';
    var W = vw(), H = vh();
    canvas.width = Math.floor(W * dpr); canvas.height = Math.floor(H * dpr);
    L.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var COLORS = ['#ff3b3b','#ffcf33','#33a2ff','#5CF08A','#ff7ad1','#ffa033','#b98bff','#ff5252'];
    var parts = [], rockets = [];
    var bursts = opts.count || 10, win = opts.windowMs || 2000;
    var soundOn = opts.sound !== false;
    var hasPerf = !!(global.performance && global.performance.now);
    var t0 = hasPerf ? global.performance.now() : 0;
    function tnow(){ return (hasPerf ? global.performance.now() : 0) - t0; }

    function launch(){
      var tx = rnd(W * 0.18, W * 0.82), ty = rnd(H * 0.12, H * 0.42);
      rockets.push({ x: tx, y: H + 8, ty: ty, vy: -(rnd(11.5, 15)), color: pick(COLORS), trail: [] });
      if (soundOn && Math.random() < 0.72) fwSound();     // hang a felszálláskor → a robbanás a boommal ér össze
    }
    function explode(x, y, color){
      var n = 70 + (Math.random() * 55 | 0);
      var base = rnd(3.4, 6.2);
      var twinkle = Math.random() < 0.55;
      var color2 = Math.random() < 0.4 ? pick(COLORS) : color;
      for (var i = 0; i < n; i++){
        var ang = rnd(0, Math.PI * 2);
        var sp = base * Math.pow(Math.random(), 0.45);     // sűrűbb mag, ritkább perem — gömbrobbanás érzet
        parts.push({
          x: x, y: y, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp,
          color: Math.random() < 0.12 ? '#fff7e0' : (Math.random() < 0.5 ? color : color2),
          life: 0, ttl: 55 + (Math.random() * 45 | 0), size: rnd(1.3, 2.7),
          twinkle: twinkle && Math.random() < 0.5
        });
      }
      parts.push({ flash: true, x: x, y: y, life: 0, ttl: 9, color: color });
    }
    function frame(){
      var el = tnow();
      // éjszakai-ég háttér (be/ki-fade), hogy a színek pattanjanak
      var peak = 0.52, a;
      if (el < 240) a = peak * (el / 240);
      else if (el < win + 300) a = peak;
      else a = Math.max(0, peak * (1 - (el - (win + 300)) / 850));
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      ctx.fillStyle = 'rgba(9,11,20,' + a.toFixed(3) + ')';
      ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';           // additív fény a részecskékre
      for (var r = rockets.length - 1; r >= 0; r--){
        var k = rockets[r]; k.y += k.vy; k.vy += 0.05;
        k.trail.push({ x: k.x, y: k.y }); if (k.trail.length > 9) k.trail.shift();
        for (var tt = 0; tt < k.trail.length; tt++){
          ctx.globalAlpha = (tt / k.trail.length) * 0.9; ctx.fillStyle = k.color;
          ctx.beginPath(); ctx.arc(k.trail[tt].x, k.trail[tt].y, 1.7, 0, 6.2832); ctx.fill();
        }
        if (k.y <= k.ty || k.vy >= 0){ explode(k.x, k.y, k.color); rockets.splice(r, 1); }
      }
      for (var p = parts.length - 1; p >= 0; p--){
        var q = parts[p];
        if (q.flash){ q.life++; var fr = q.life / q.ttl; if (fr >= 1){ parts.splice(p, 1); continue; }
          ctx.globalAlpha = (1 - fr) * 0.9; ctx.fillStyle = q.color;
          ctx.beginPath(); ctx.arc(q.x, q.y, 8 + fr * 46, 0, 6.2832); ctx.fill(); continue; }
        q.life++; q.vx *= 0.986; q.vy *= 0.986; q.vy += 0.045; q.x += q.vx; q.y += q.vy;
        var lr = q.life / q.ttl; if (lr >= 1){ parts.splice(p, 1); continue; }
        var alpha = 1 - lr;
        if (q.twinkle && lr > 0.45) alpha *= (Math.random() < 0.5 ? 0.25 : 1);   // pislákolás
        ctx.globalAlpha = Math.max(0, alpha); ctx.fillStyle = q.color;
        ctx.beginPath(); ctx.arc(q.x, q.y, q.size, 0, 6.2832); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (el < win + 1300 || parts.length || rockets.length) global.requestAnimationFrame(frame);
      else { ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, canvas.width, canvas.height); canvas.remove(); }
    }
    global.requestAnimationFrame(frame);
    for (var b = 0; b < bursts; b++){
      (function (b){ setTimeout(launch, (b / bursts) * win + rnd(0, (win / bursts) * 0.7)); })(b);
    }
  }

  // ---------- pont-effektek ----------
  function place(el, w, h) {
    var L = getLayer(), wrap = doc.createElement('div');
    wrap.style.position='absolute'; wrap.style.left='50%'; wrap.style.top='50%';
    wrap.style.width=w+'px'; wrap.style.height=h+'px'; wrap.style.transformOrigin='center';
    L.appendChild(wrap); return wrap;
  }
  function atPoint(x, y) {
    var L = getLayer(), wrap = doc.createElement('div');
    wrap.style.position='absolute'; wrap.style.left=x+'px'; wrap.style.top=y+'px';
    L.appendChild(wrap); return wrap;
  }
  function targetCenter(el) {
    if (!el) return { x: vw()/2, y: vh()/2 };
    var r = el.getBoundingClientRect();
    return { x: r.left + r.width/2, y: r.top + r.height/2 };
  }

  function sparkle(x, y, color) {
    injectStyle(); var L = getLayer();
    color = color || pick([RED, COPPER, INK]);
    for (var i = 0; i < 5; i++) {
      var s = doc.createElement('div');
      var px = (x!=null?x:vw()/2) + rnd(-26,26), py = (y!=null?y:vh()/2) + rnd(-26,26);
      s.style.position='absolute'; s.style.left=px+'px'; s.style.top=py+'px';
      var sz = rnd(10,20);
      s.innerHTML = '<svg width="'+sz+'" height="'+sz+'" viewBox="0 0 24 24" fill="'+color+'">' +
        '<path d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z"/></svg>';
      s.style.animation = 'mtfx-spark ' + rnd(0.5,0.8) + 's ease-out forwards';
      s.style.animationDelay = (i*0.04)+'s';
      L.appendChild(s);
      (function(node){ setTimeout(function(){ node.remove(); }, 900); })(s);
    }
  }

  function checkPop(el) {
    injectStyle(); var c = targetCenter(el), L = getLayer();
    // gyűrű
    var ring = doc.createElement('div');
    ring.style.cssText='position:absolute;left:'+c.x+'px;top:'+c.y+'px;width:120px;height:120px;border-radius:50%;border:3px solid '+RED+';animation:mtfx-ring .6s ease-out forwards';
    L.appendChild(ring); setTimeout(function(){ring.remove();}, 650);
    // pipa
    var w = doc.createElement('div');
    w.style.cssText='position:absolute;left:'+c.x+'px;top:'+c.y+'px;animation:mtfx-pop .45s cubic-bezier(.2,.9,.3,1.3) forwards';
    w.innerHTML='<svg width="86" height="86" viewBox="0 0 24 24" fill="none">' +
      '<circle cx="12" cy="12" r="11" fill="'+RED+'"/>' +
      '<path d="M7 12.5 L10.5 16 L17 8.5" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    L.appendChild(w);
    setTimeout(function(){ w.style.animation='mtfx-popout .4s ease forwards'; setTimeout(function(){w.remove();},420); }, 900);
  }

  function coin(el) {
    injectStyle(); var c = targetCenter(el), L = getLayer();
    var w = doc.createElement('div');
    w.style.cssText='position:absolute;left:'+c.x+'px;top:'+c.y+'px;animation:mtfx-coin .9s cubic-bezier(.2,.7,.3,1) forwards';
    w.innerHTML='<svg width="64" height="64" viewBox="0 0 64 64">' +
      '<circle cx="32" cy="32" r="29" fill="'+COPPER+'" stroke="'+INK+'" stroke-width="2"/>' +
      '<circle cx="32" cy="32" r="23" fill="none" stroke="#fff" stroke-width="1.5" opacity=".7"/>' +
      '<text x="32" y="41" text-anchor="middle" font-family="Montserrat,Arial,sans-serif" font-weight="800" font-size="24" fill="#fff">MT</text></svg>';
    L.appendChild(w);
    setTimeout(function(){ w.style.transition='opacity .3s'; w.style.opacity='0'; setTimeout(function(){w.remove();},320); }, 1000);
  }

  function badge(el) {
    injectStyle(); var c = targetCenter(el), L = getLayer();
    var w = doc.createElement('div');
    w.style.cssText='position:absolute;left:'+c.x+'px;top:'+c.y+'px;animation:mtfx-badge .55s cubic-bezier(.2,.9,.3,1.3) forwards';
    w.innerHTML='<svg width="92" height="92" viewBox="0 0 96 96">' +
      '<circle cx="48" cy="44" r="30" fill="'+INK+'"/>' +
      '<circle cx="48" cy="44" r="30" fill="none" stroke="'+RED+'" stroke-width="3"/>' +
      '<path d="M30 44.5 L43 56 L67 31" stroke="#fff" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M34 70 L30 90 L48 80 L66 90 L62 70 Z" fill="'+RED+'"/></svg>';
    L.appendChild(w);
    setTimeout(function(){ w.style.transition='opacity .35s'; w.style.opacity='0'; setTimeout(function(){w.remove();},360); }, 1500);
  }

  // ---------- VERSENYAUTÓ (áthalad a képernyőn) ----------
  function car(opts) {
    opts = opts || {}; var L = getLayer();
    var col = pick([RED, INK, COPPER]);
    var y = vh() * 0.56, dur = opts.dur || 1.3;
    var wrap = doc.createElement('div');
    wrap.style.cssText = 'position:absolute;top:' + y + 'px;left:0;transform:translateX(-280px);will-change:transform';
    wrap.innerHTML = '<svg width="220" height="112" viewBox="0 0 220 112" style="overflow:visible">' +
      '<g stroke="' + col + '" stroke-width="4" stroke-linecap="round" opacity=".5">' +
        '<line x1="-30" y1="46" x2="30" y2="46"/><line x1="-14" y1="62" x2="42" y2="62"/><line x1="-24" y1="76" x2="24" y2="76"/></g>' +
      '<path d="M40 80 Q42 58 68 56 L94 40 Q112 32 142 34 L170 40 Q190 46 202 64 L206 80 Q206 88 198 88 L48 88 Q40 88 40 80 Z" fill="' + col + '" stroke="' + INK + '" stroke-width="2"/>' +
      '<path d="M100 44 L140 44 L162 56 L98 56 Z" fill="#fff" opacity=".85"/>' +
      '<line x1="122" y1="44" x2="122" y2="56" stroke="' + col + '" stroke-width="3"/>' +
      '<circle cx="80" cy="88" r="17" fill="' + INK + '"/><circle cx="80" cy="88" r="6.5" fill="#cfcfcf"/>' +
      '<circle cx="172" cy="88" r="17" fill="' + INK + '"/><circle cx="172" cy="88" r="6.5" fill="#cfcfcf"/></svg>';
    L.appendChild(wrap);
    global.requestAnimationFrame(function () {
      wrap.style.transition = 'transform ' + dur + 's cubic-bezier(.45,.05,.55,.95)';
      wrap.style.transform = 'translateX(' + (vw() + 300) + 'px)';
    });
    setTimeout(function () { wrap.remove(); }, dur * 1000 + 300);
  }

  // ---------- ÉRMEESŐ ----------
  function coinRain(opts) {
    opts = opts || {}; var L = getLayer();
    var count = opts.count || 34;
    var svg = '<svg width="30" height="30" viewBox="0 0 30 30">' +
      '<circle cx="15" cy="15" r="13" fill="' + COPPER + '" stroke="' + INK + '" stroke-width="1.5"/>' +
      '<circle cx="15" cy="15" r="8.5" fill="none" stroke="#fff" stroke-width="1.4" opacity=".6"/></svg>';
    var arr = [];
    for (var i = 0; i < count; i++) {
      var d = doc.createElement('div');
      var x = rnd(0, vw());
      d.style.cssText = 'position:absolute;left:' + x + 'px;top:0;will-change:transform';
      d.innerHTML = svg; L.appendChild(d);
      arr.push({ el: d, y: rnd(-vh() * 0.5, -20), vy: rnd(3, 6.5), rot: rnd(0, 360), vr: rnd(6, 15), life: 0, ttl: rnd(140, 220) });
    }
    var grav = 0.16;
    function frame() {
      var alive = 0;
      for (var i = 0; i < arr.length; i++) {
        var p = arr[i]; if (!p.el) continue;
        p.vy += grav; p.y += p.vy; p.rot += p.vr; p.life++;
        var op = p.y > vh() * 0.78 ? Math.max(0, 1 - (p.y - vh() * 0.78) / (vh() * 0.22)) : 1;
        p.el.style.transform = 'translateY(' + p.y + 'px) rotateY(' + p.rot + 'deg)';
        p.el.style.opacity = op;
        if (p.y < vh() + 40 && p.life < p.ttl) alive++; else { p.el.remove(); p.el = null; }
      }
      if (alive > 0) global.requestAnimationFrame(frame);
    }
    global.requestAnimationFrame(frame);
  }

  // ---------- CSILLAGSZÓRÓ ----------
  function starBurst(x, y, opts) {
    injectStyle(); opts = opts || {}; var L = getLayer();
    var cx = x != null ? x : vw() / 2, cy = y != null ? y : vh() / 2;
    var count = opts.count || 26;
    var starPath = 'M12 0 L14.6 8.4 L23 9 L16 14.2 L18.4 22.4 L12 17.4 L5.6 22.4 L8 14.2 L1 9 L9.4 8.4 Z';
    for (var i = 0; i < count; i++) {
      var a = (i / count) * Math.PI * 2 + rnd(-0.1, 0.1);
      var dist = rnd(120, 250), sz = rnd(12, 26);
      var col = pick([RED, COPPER, '#F0B23E', WHITE, INK]);
      var s = doc.createElement('div');
      s.style.cssText = 'position:absolute;left:' + cx + 'px;top:' + cy + 'px;' +
        '--dx:' + (Math.cos(a) * dist) + 'px;--dy:' + (Math.sin(a) * dist) + 'px;--rot:' + rnd(-180, 180) + 'deg;' +
        'animation:mtfx-fly ' + rnd(0.7, 1.1) + 's cubic-bezier(.1,.7,.3,1) forwards';
      s.innerHTML = '<svg width="' + sz + '" height="' + sz + '" viewBox="0 0 24 24" fill="' + col + '"><path d="' + starPath + '"/></svg>';
      L.appendChild(s);
      (function (node) { setTimeout(function () { node.remove(); }, 1300); })(s);
    }
    for (var j = 0; j < 16; j++) {
      var t = doc.createElement('div');
      var tsz = rnd(6, 14);
      t.style.cssText = 'position:absolute;left:' + rnd(0, vw()) + 'px;top:' + rnd(0, vh() * 0.85) + 'px;' +
        'animation:mtfx-spark ' + rnd(0.6, 1) + 's ease-out ' + rnd(0, 0.4) + 's forwards';
      t.innerHTML = '<svg width="' + tsz + '" height="' + tsz + '" viewBox="0 0 24 24" fill="' + pick([RED, COPPER, WHITE]) + '"><path d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z"/></svg>';
      L.appendChild(t);
      (function (node) { setTimeout(function () { node.remove(); }, 1500); })(t);
    }
  }

  // ---------- LUFI-FELSZÁLLÁS ----------
  function balloons(opts) {
    opts = opts || {}; var L = getLayer();
    var count = opts.count || 12, arr = [];
    for (var i = 0; i < count; i++) {
      var col = pick([RED, COPPER, INK, '#E23B41', '#F0B23E']);
      var w = rnd(34, 54), x = rnd(vw() * 0.04, vw() * 0.92);
      var d = doc.createElement('div');
      d.style.cssText = 'position:absolute;left:' + x + 'px;top:0;will-change:transform';
      d.innerHTML = '<svg width="' + w + '" height="' + (w * 1.5) + '" viewBox="0 0 40 60">' +
        '<ellipse cx="20" cy="21" rx="18" ry="21" fill="' + col + '"/>' +
        '<ellipse cx="13" cy="14" rx="4.5" ry="6.5" fill="#fff" opacity=".28"/>' +
        '<path d="M20 42 l-3 6 h6 z" fill="' + col + '"/>' +
        '<path d="M20 48 q3 6 -1 12" stroke="' + INK + '" stroke-width="1" fill="none" opacity=".5"/></svg>';
      L.appendChild(d);
      arr.push({ el: d, y: vh() + rnd(0, 240), vy: rnd(1.5, 3), amp: rnd(12, 30), ph: rnd(0, 6.28), life: 0 });
    }
    function frame() {
      var alive = 0;
      for (var i = 0; i < arr.length; i++) {
        var p = arr[i]; if (!p.el) continue;
        p.y -= p.vy; p.life++;
        var sway = Math.sin(p.life * 0.03 + p.ph) * p.amp;
        p.el.style.transform = 'translate(' + sway + 'px,' + p.y + 'px)';
        if (p.y > -140) alive++; else { p.el.remove(); p.el = null; }
      }
      if (alive > 0) global.requestAnimationFrame(frame);
    }
    global.requestAnimationFrame(frame);
  }

  // ---------- FŐ győzelmi kombó ----------
  function celebrate(opts) {
    opts = opts || {};
    fireworks({ count: opts.bursts || 8 });
    confetti({ count: opts.count || 150 });
    checkPop(opts.target || null);
    if (global.MovtechSFX && opts.sound !== false) global.MovtechSFX.play('success');
  }

  global.MovtechFX = {
    confetti: confetti, fireworks: fireworks, sparkle: sparkle,
    checkPop: checkPop, coin: coin, badge: badge, celebrate: celebrate,
    car: car, coinRain: coinRain, starBurst: starBurst, balloons: balloons,
    colors: { red: RED, ink: INK, white: WHITE, copper: COPPER }
  };
})(typeof window !== 'undefined' ? window : this, document);
